import { captureException } from "@sentry/vue";
import { safe_redirect } from 'utilities';

export function ajax( config ) {
	const {
		method,
		data,
		form_data,
		endpoint,
		signal,
		on_success,
		on_error,
		on_complete
	} = config;

	let code = null;

	const headers = {};

	if( !form_data ) {
		headers[`Content-Type`] = `application/json`;
	}

	fetch( `/${endpoint}`, {
		method,
		credentials: `include`,
		signal,
		headers,
		body: form_data ? form_data : JSON.stringify( data )
	} )
		.then( response => {
			code = response.status;

			return response.text();
		} )
		.then( str => {
			let resp = null;

			try {
				// Use data if JSON
				resp = JSON.parse( str );
			} catch {
				// captureException( error );

				// Otherwise use as string
				resp = str;
			}

			return resp;
		} )
		.then( response => {
			if ( code >= 200 && code <= 299 ) {
				if ( on_success ) {
					on_success( response, code );
				}
			} else if ( code >= 300 && code <= 399 ) {
				safe_redirect( response );
			} else if ( on_error ) {
				on_error( response, code );
			}

			return response;
		} )
		.catch( response => {
			if( response instanceof Error && ( response.message === `Failed to fetch` || response.message === `Load failed` ) ) {
				// Skip capture for network errors
			} else {
				captureException( response );
			}

			if ( on_error ) {
				on_error( response, code );
			}

			return response;
		} )
		.then( () => {
			if ( on_complete ) {
				on_complete( code );
			}
		} );
}

export async function async_ajax( config ) {
	const {
		method,
		data,
		form_data,
		endpoint,
		signal
	} = config;

	const headers = {};

	if( !form_data ) {
		headers[`Content-Type`] = `application/json`;
	}

	const response = await fetch( `/${endpoint}`, {
		method,
		credentials: `include`,
		signal,
		headers,
		body: form_data ? form_data : JSON.stringify( data )
	} );

	if( !response.ok ) {
		const error = await response.json();

		throw error.message || error;
	}

	const text = await response.text();

	return text ? JSON.parse( text ) : null;
}
